import React from 'react';
import { DialogContainer } from '~/src/components/Modal/mui/DialogContainer';
import { MessageDialog } from '~/src/components/Modal/mui/MessageDialog';
import Button from '~/src/components/Button';
import { useRenewSubscription } from '~/src/entities/subscription';
import { useStore } from '~/src/hooks/useMst';
import { useSnackbar } from 'notistack';

export type RenewSubscriptionConfirmModalProps = {
  open: boolean;
  onRenewed: () => void;
  onClose: () => void;
};

export const RenewSubscriptionConfirmModal = ({
  open,
  onRenewed,
  onClose,
}: RenewSubscriptionConfirmModalProps) => {
  const store = useStore();
  const snackbar = useSnackbar();
  const { mutate, isLoading } = useRenewSubscription({
    onSuccess: () => {
      store.user.currentOrganization?.fetchSubscription();
      onRenewed();
    },
    onError: () => {
      snackbar.enqueueSnackbar(
        'Something went wrong, please contact support.',
        { variant: 'error' },
      );
    },
  });

  return (
    <DialogContainer open={open} onClose={onClose}>
      <MessageDialog
        title="Renew subscription"
        onClose={onClose}
        showCloseButton={true}
        dialogActions={
          <>
            <Button
              data-testid="renew-subscription-modal-confirm"
              onClick={() => mutate()}
              disabled={isLoading}
              primary
              style={{ fontWeight: 600 }}
            >
              {isLoading ? 'Renewing...' : 'Confirm renewal'}
            </Button>
          </>
        }
      >
        <div>
          <div style={{ marginBottom: '8px' }}>
            By renewing your subscription, your credit card will be charged
            immediately.
          </div>
          <div>
            Contact our Support team if you have any questions about your
            subscription.
          </div>
        </div>
      </MessageDialog>
    </DialogContainer>
  );
};
